import React from 'react';
import './loader.css';
export const Loader = () => {
    return (React.createElement("div", { className: "loader g-page-without-header-footer" },
        React.createElement("span", null, "Loading...")));
};
